import {
	MarketingPage,
	MarketingSection,
} from './+shared/marketing-page.tsx'
import { type Route } from './+types/about.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Over ons — Muziekdocent' },
	{
		name: 'description',
		content:
			'Waarom we Muziekdocent bouwen: muziekles die klinkt zoals wat leerlingen zelf luisteren.',
	},
]

export default function AboutRoute() {
	return (
		<MarketingPage
			title="Over Muziekdocent"
			intro="Muziekles die klinkt zoals wat leerlingen zelf luisteren — dat is het hele idee."
		>
			<MarketingSection title="Waarom we dit bouwen">
				<p>
					De meeste digitale muziektools zijn speelgoed voor thuis, met een
					docentenpaneeltje erbij geplakt. Wij draaiden het om: Muziekdocent
					begint bij de lesvoorbereiding van de docent en eindigt bij een
					leerling die trots een eigen beat laat horen.
				</p>
			</MarketingSection>

			<MarketingSection title="Voor het Nederlandse onderwijs">
				<p>
					Gebouwd voor het voortgezet onderwijs: Entree Federatie SSO,
					differentiatie voor VMBO/HAVO/VWO, werkt op Chromebooks en
					schoolpc's, gehost in de EU en AVG-veilig met een standaard
					verwerkersovereenkomst.
				</p>
			</MarketingSection>

			<MarketingSection title="Contact">
				<p>
					Muziekdocent AI B.V., Amsterdam.{' '}
					<a
						href="mailto:info@muziekdocent.nl"
						className="text-white underline underline-offset-4"
					>
						info@muziekdocent.nl
					</a>
				</p>
			</MarketingSection>
		</MarketingPage>
	)
}
